import template from './addSubcontractorToContractModal.html';
import controller from './addSubcontractorToContractModal.controller';

let AddSubcontractorToContractModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-success animated zoomIn"
};

export default AddSubcontractorToContractModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/addSubcontractorToContractModal/addSubcontractorToContractModal.component.js